import object1 from "./1.png";

export const householdCleansing1 = [
  object1,
  object1,
  object1,
  object1,
  object1,
];
